import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Comment, Stack } from "@air/next-icons";
import { memo, useCallback, useMemo } from "react";
import { PublicAssetMobileNavigationEllipsisMenu } from "~/_app/(public-asset)/_components/PublicAssetMobileNavigationEllipsisMenu";
import { MobileAssetModalNavigation } from "~/_components/MobileAssetModalNavigation";
import { MobileAssetModalNavigationItem } from "~/_components/MobileAssetModalNavigationItem";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { AssetModalPanel, useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
import { canSeeAssetVersions, canViewAssetDiscussions } from "~/utils/permissions/assetPermissions";
export const PublicMobileAssetModalNavigation = /*#__PURE__*/ memo(()=>{
    const { panel, togglePanel } = useAssetModalPanelContext();
    const { permissions } = usePublicPermissions();
    const canViewDiscussions = canViewAssetDiscussions(permissions);
    const canViewAllVersions = canSeeAssetVersions(permissions);
    const navigationItems = useMemo(()=>{
        const navigationItemsArray = [];
        if (canViewDiscussions) {
            navigationItemsArray.push({
                id: AssetModalPanel.COMMENTS,
                icon: Comment,
                label: "Comments",
                order: 2
            });
        }
        if (canViewAllVersions) {
            navigationItemsArray.push({
                id: AssetModalPanel.VERSIONS,
                icon: Stack,
                label: "Version",
                order: 7
            });
        }
        return navigationItemsArray;
    }, [
        canViewAllVersions,
        canViewDiscussions
    ]);
    const onClick = useCallback((panel)=>{
        togglePanel(panel);
    // @TODO - Future change
    // Scroll to position when panel is changed
    // if (panel === AssetModalPanel.COMMENTS) {
    //   scrollToBottom();
    // } else {
    //   scrollToPanel();
    // }
    }, [
        togglePanel
    ]);
    return /*#__PURE__*/ _jsxs(MobileAssetModalNavigation, {
        children: [
            navigationItems.map((item)=>{
                const isActive = panel === item.id || // @TODO - Remove once new UI is fully implemented
                item.id === AssetModalPanel.INFO && (!panel || panel === AssetModalPanel.NONE);
                return /*#__PURE__*/ _jsx(MobileAssetModalNavigationItem, {
                    icon: item.icon,
                    id: item.id,
                    isActive: isActive,
                    label: item.label,
                    onClick: ()=>onClick(item.id),
                    order: item.order
                }, item.id);
            }),
            /*#__PURE__*/ _jsx(PublicAssetMobileNavigationEllipsisMenu, {})
        ]
    });
});
PublicMobileAssetModalNavigation.displayName = "PublicMobileAssetModalNavigation";
